var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9957 5.71429H8.57143C7.81367 5.71429 7.08694 6.01531 6.55112 6.55112C6.01531 7.08694 5.71429 7.81367 5.71429 8.57143V16.9957C5.2133 16.8179 4.7796 16.4895 4.47267 16.0554C4.16575 15.6214 4.00064 15.103 4 14.5714V6.57143C4 5.88944 4.27092 5.23539 4.75315 4.75315C5.23539 4.27092 5.88944 4 6.57143 4H14.5714C15.103 4.00064 15.6214 4.16575 16.0554 4.47267C16.4895 4.7796 16.8179 5.2133 16.9957 5.71429ZM9.42857 20H17.4286C18.1106 20 18.7646 19.7291 19.2468 19.2468C19.7291 18.7646 20 18.1106 20 17.4286V9.42857C20 8.74659 19.7291 8.09253 19.2468 7.6103C18.7646 7.12806 18.1106 6.85714 17.4286 6.85714H9.42857C8.74659 6.85714 8.09253 7.12806 7.6103 7.6103C7.12806 8.09253 6.85714 8.74659 6.85714 9.42857V17.4286C6.85714 18.1106 7.12806 18.7646 7.6103 19.2468C8.09253 19.7291 8.74659 20 9.42857 20Z",
    fill: "#D1FE17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.fd6cb28c2faf0bb91aff98c98d369f05.svg";
export { ForwardRef as ReactComponent };